import React, { useState } from "react";
import { Box, Button, Chip, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Industries from "./Industries";

const filters = [
  "All",
  "E-commerce",
  "Healthcare",
  "Banking",
  "Education",
  "Hospitality",
  "Automobile",
  "Insurance",
];

function SectorSection() {
  const [selectedFilter, setSelectedFilter] = useState(""); // Allow only one filter
  const navigate = useNavigate(); // For navigation to another page

  const handleChipClick = (filter) => {
    setSelectedFilter((prev) => (prev === filter ? "" : filter)); // Toggle the selected filter
  };

  const handleMoreFilters = () => {
    navigate("/industries-details"); // Navigate to "more-items" page
  };

  return (
    <Box
      // p={2}
      sx={{
        width: { xl: "74%", lg: "90%", md: "80%", sm: "90%", xs: "100%" },
        // border: "1px solid red",
        height: { xl: "60px", lg: "40px" },
      }}
    >
      <Stack
        sx={{
          display: "flex",
          flexDirection: {
            xl: "row",
            lg: "row",
            md: "row",
            sm: "row",
            xs: "row",
          },
          // border: "2px solid red",
          borderRadius: "8px",
          height: "100%",
          alignItems: "center",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Stack
          sx={{
            // border: "1px solid blue",
            width: { xl: "88%", lg: "94%", xs: "70%" },
            height: { xl: "80%" },
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            overflowX: "hidden", // Prevent content from overflowing
            overflowY: "hidden",
            marginLeft: { xl: "8px", lg: "8px" },
            marginRight: { xl: "8px", lg: "8px" },
          }}
        >
          <Industries />
        </Stack>

        <Stack
          sx={{
            // border: "1px solid green",
            width: { xl: "11%", lg: "11%", md: "11%", sm: "11%", xs: "26%" },
            marginLeft: {
              xl: "0px",
              lg: "0px",
              md: "0px",
              sm: "0px",
              xs: "20px",
            },
            height: { xl: "80%" },
            display: "flex",
            flexDirection: { xl: "row", lg: "row" },
            justifyContent: "center",
            alignItems: "center",
            marginRight: { xl: "16px", lg: "8px" },
            marginBottom: {
              xl: "none",
              lg: "none",
              md: "none",
              sm: "none",
              xs: "8px",
            },
          }}
        >
          <Button
            variant="outlined"
            onClick={handleMoreFilters}
            sx={{
              whiteSpace: "nowrap", // Prevent text wrapping
              mx: 2,
              // border: "none",
              width: "90%",
              fontSize: { xl: "12px", lg: "12px", xs: "12px" },
              marginTop: {
                xl: "6px",
                lg: "0px",
                md: "0px",
                sm: "0px",
                xs: "6px",
              },
              paddingRightRight: {
                xl: "0px",
                lg: "0px",
                md: "0px",
                sm: "0px",
                xs: "8px",
              },
              fontFamily:
                "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
              borderColor: "#4c3bea",
              color: "#4c3bea",

              "&:hover": {
                backgroundColor: "#4c3bea",
                color: "white",
                borderColor: "#4c3bea",
              },
            }}
          >
            View all →
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export default SectorSection;
